import classNames from "classnames";
import React from "react";

import Img from "@components/FileServer/Img";
import FormattedMessage from "@components/UI/FormattedMessage";
import SearchStepsMobile from "@components/UI/Header/SearchStepsMobile";

import useMediaQuery from "../../../hooks/useMediaQuery";

function Divider() {
  return <div className="search-steps-divider" />;
}

interface StepProps {
  activeStep: number;
  stepNumber: number;
  text: React.ReactElement;
}

function Step({ activeStep, stepNumber, text }: StepProps) {
  const active = activeStep === stepNumber;
  const finished = activeStep > stepNumber;
  return (
    <>
      <span
        className={classNames("search-steps-circle", {
          "search-steps-circle-active": active,
          "search-steps-circle-finished": finished,
        })}
      >
        {finished ? (
          <Img src="/static/images/ico-check.svg" alt="check icon" />
        ) : (
          <span className="search-steps-circle-step-number">{stepNumber}</span>
        )}
      </span>
      <span
        className={classNames("search-steps-label", {
          "search-steps-label-active": active,
          "search-steps-label-finished": finished,
        })}
      >
        {text}
      </span>
    </>
  );
}

interface Props {
  page: string;
}

function SearchSteps({ page }: Props) {
  const isDesktop = useMediaQuery(1010);

  if (!isDesktop) {
    return <SearchStepsMobile page={page} />;
  }

  const isBestOfferResults = page === "bestOfferResults";
  let activeStep = 1;
  if (isBestOfferResults || page === "result" || page === "hotel") {
    activeStep = 2;
  }
  if (page === "booked" || page === "hotelBook") {
    activeStep = 3;
  }
  if (page === "hotelBooked") {
    activeStep = 4;
  }

  return (
    <div
      className={classNames("search-steps-desktop", {
        "search-steps-desktop--result": page === "result",
        "search-steps-desktop--hotelBook": page === "hotelBook",
        "search-steps-desktop--booked": page === "booked",
        "search-steps-desktop--hotels": page === "hotelsResults",
        "search-steps-desktop--hotel": page === "hotel",
        "search-steps-desktop--hotelBooked": page === "hotelBooked",
      })}
    >
      <div className="search-steps-wrapper">
        <Step
          activeStep={activeStep}
          stepNumber={1}
          text={
            page.includes("hotel") ? (
              <FormattedMessage id="SearchSteps.chooseHotel" />
            ) : isBestOfferResults ? (
              <FormattedMessage id="BestOffers.title" />
            ) : (
              <FormattedMessage id="SearchSteps.chooseFlight" />
            )
          }
        />

        {page.includes("hotel") && (
          <>
            <Divider />

            <Step
              activeStep={activeStep}
              stepNumber={2}
              text={<FormattedMessage id="SearchSteps.selectRooms" />}
            />
          </>
        )}

        <Divider />

        <Step
          activeStep={activeStep}
          stepNumber={page.includes("hotel") ? 3 : 2}
          text={
            isBestOfferResults ? (
              <FormattedMessage id="BestOffers.pickFlight" />
            ) : (
              <FormattedMessage id="SearchSteps.yourInformation" />
            )
          }
        />

        <Divider />

        <Step
          activeStep={activeStep}
          stepNumber={page.includes("hotel") ? 4 : 3}
          text={<FormattedMessage id="Result.confirmBooking" />}
        />
      </div>
    </div>
  );
}

export default SearchSteps;
